import { render, staticRenderFns } from "./seasonprices.vue?vue&type=template&id=c97b842e&"
import script from "./seasonprices.vue?vue&type=script&lang=js&"
export * from "./seasonprices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c97b842e')) {
      api.createRecord('c97b842e', component.options)
    } else {
      api.reload('c97b842e', component.options)
    }
    module.hot.accept("./seasonprices.vue?vue&type=template&id=c97b842e&", function () {
      api.rerender('c97b842e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2wVQyTUPRsAZ9/JS/comp/seasonprices.vue"
export default component.exports